import useFormat from '@business/utils/hooks/useFormat';
import { Flex } from '@chakra-ui/react';
import { useStore } from '@data/other/withStore';
import { BEPopover, PopoverProps } from '@molecules/BEOffScreen/Popover';
import Text from '@molecules/Text';
import { useMemo } from 'react';

const TaxesAndFees = (popoverProps: PopoverProps) => {
  const {
    property: { cart },
  } = useStore();
  const { currency } = useFormat();

  const taxesAndFees = useMemo(() => {
    if (!cart.totals) return [];
    const res: Dict[] = [...cart.totals.taxes.data, ...cart.totals.fees.data];
    return res;
  }, []);

  return (
    <BEPopover {...popoverProps}>
      <Flex
        w="200px"
        gap="6px"
        p="8px"
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {taxesAndFees.map((item, index) => (
          <Flex key={index} w="100%" justifyContent="space-between">
            <Text type="card-body" size="md">
              {item.name}
            </Text>
            <Text type="card-body" size="md">
              {currency(item.credit)}
            </Text>
          </Flex>
        ))}
      </Flex>
    </BEPopover>
  );
};

export default TaxesAndFees;
